export default {"src":"/_next/static/media/GML.a95cb328.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};